import { debounce } from 'radash'
import { useMemo } from 'react'

/**
 * @description 일정시간 내에 반복적으로 이벤트가 발생했을 때, 이벤트 횟수와 관계없이 마지막 이벤트가 발생한 후 일정시간 뒤에 콜백함수를 한번만 호출합니다.
 * @param onEvent 지연 실행시킬 함수
 * @param delay 지연 시간. 단위: ms
 */
const useDebouncedEvent = (onEvent?: (event?: any) => Promise<void> | void, delay = 500) => {
  return useMemo(
    () =>
      debounce({ delay }, (event?: any) => {
        onEvent?.(event)
      }),
    // ! 아래 dependencies 삽입 시 의도대로 동작 안함
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )
}

export default useDebouncedEvent
